<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card >
            <div class="groups">
                <div class="buttons">
                    <b-button title="Ekle" variant="primary" @click="openModal(true,'add')">Yeni Ekle </b-button>
                </div>
                <b-form inline class="formBox"> 
                    <div  class="inputGrp" >
                        <b-table-simple hover responsive>
                            <b-thead>
                                <b-th> Not Tipi </b-th>
                                <b-th> Trafik List </b-th>
                                <b-th> Sinyal Değerlendirme </b-th>
                                <b-th> İşlemler </b-th>
                            </b-thead>
                            <b-tbody>
                                <b-tr>
                                    <b-td> Arıza Notu </b-td>
                                    <b-td> <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td> <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td > 
                                        <div class="buttons">
                                            <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                                            <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                                        </div>
                                   </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td> Bilgilendirme </b-td>
                                    <b-td> <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td> <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td > 
                                        <div class="buttons">
                                            <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                                            <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                                        </div>
                                   </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td> Ödeme </b-td>
                                    <b-td> <b-icon icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td> <b-icon icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" ></b-icon>  </b-td>
                                    <b-td > 
                                        <div class="buttons">
                                            <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                                            <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                                        </div>
                                   </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                   
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';


    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.signalGroup'), url: "/Customer/SignalGroup" },
    ]
    export default {
        name: "NoteType",
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"NoteType",
                modalName: "",
            }
        },
        components:{
            BreadCrumb, Modals
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/NoteType.vue